export default __webpack_public_path__ + "static/media/Dark_Blue_Rect.4f970ff6.png";